const safeGetCrmPropertyValue = (crmObject, property) => {
  var _crmObject$properties, _crmObject$properties2;
  return (_crmObject$properties = (_crmObject$properties2 = crmObject.properties[property]) === null || _crmObject$properties2 === void 0 ? void 0 : _crmObject$properties2.value) !== null && _crmObject$properties !== void 0 ? _crmObject$properties : '';
};
export const safeGetCrmProperties = (crmObject, properties) => Object.fromEntries(Object.entries(properties).map(([key, crmProperty]) => [key, safeGetCrmPropertyValue(crmObject, crmProperty)]));
export const notHasProperty = property => ({
  operator: 'NOT_HAS_PROPERTY',
  property
});
export const propertyNotEquals = (property, value) => ({
  operator: 'NEQ',
  property,
  value
});
export const propertyEquals = (property, value) => ({
  operator: 'EQ',
  property,
  value
});